import { render, staticRenderFns } from "./TitleBox.vue?vue&type=template&id=83c98ad6&scoped=true&"
import script from "./TitleBox.vue?vue&type=script&lang=js&"
export * from "./TitleBox.vue?vue&type=script&lang=js&"
import style0 from "./TitleBox.vue?vue&type=style&index=0&id=83c98ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c98ad6",
  null
  
)

export default component.exports